import { Component, inject } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { Contributor, ContributorRole } from '@models';

@Component({
  selector: 'app-map-archive-contributors-form',
  templateUrl: './contributors.component.html',
  styleUrls: ['./contributors.component.scss'],
  imports: [
    KeyValuePipe,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class MapArchiveContributorsFormComponent {
  dialogRef =
    inject<MatDialogRef<MapArchiveContributorsFormComponent>>(MatDialogRef);

  public contributorForm: FormGroup;

  public name: FormControl;
  public roles: FormControl;
  public email: FormControl;

  public contributorRoles = ContributorRole;

  constructor() {
    const contrib = inject<Contributor>(MAT_DIALOG_DATA);

    this.name = new FormControl(contrib?.name, {
      validators: [Validators.required],
    });
    this.email = new FormControl(contrib?.email, {
      validators: [Validators.email],
    });
    this.roles = new FormControl(contrib?.roles, {
      validators: [Validators.required],
    });

    this.contributorForm = new FormGroup({
      name: this.name,
      roles: this.roles,
      email: this.email,
    });
  }

  submit() {
    if (this.contributorForm.pristine || !this.contributorForm.valid) {
      return;
    }

    const formData = {
      name: this.contributorForm.value.name,
      roles: this.contributorForm.value.roles,
      email: this.contributorForm.value.email || undefined,
    };

    this.dialogRef.close(formData);
  }

  cancel() {
    this.dialogRef.close();
  }
}
